import * as yup from "yup";
import { isValidDateTest, maxLengthMessage } from "../../../utils/functions";

const participantSchema = yup.object().shape({
  employeeNum: yup
    .string()
    .trim()
    .max(50, maxLengthMessage(50))
    .required("Employee # is required")
    .nonNullable(),
  courseNumber: yup
    .string()
    .trim()
    .max(25, maxLengthMessage(25))
    .required("Course Number is required")
    .nonNullable(),
  course: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  courseDate: isValidDateTest("Course Date"),
  attendedDate: isValidDateTest("Attended Date"),
  courseLocation: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  dateRegistered: isValidDateTest("Date Registered"),
  hours: yup
    .number()
    .transform((value, originalValue) => {
      // Convert empty string to null
      return originalValue === "" ? null : Number(originalValue);
    })
    .nullable()
    .positive()
    .integer(),
  grade: yup.string().trim().max(10, maxLengthMessage(10)).nullable(),
  category: yup.string().trim().max(20, maxLengthMessage(20)).nullable(),
  approved: yup.boolean().nullable(),
  checkSent: yup.boolean().nullable(),
  dateCheckSent: isValidDateTest("Check Date Sent"),
  approvedBy: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  comments: yup.string().trim().nullable(),
  participantNumber: yup
    .string()
    .trim()
    .max(100, maxLengthMessage(100))
    .required("Participant Number is required")
    .nonNullable(),
});

export default participantSchema;
